export type StatProgressBarVariant = 'auto' | 'success' | 'warning' | 'danger'

export type StatProgressBarProps = {
    value: number
    variant?: StatProgressBarVariant
    className?: string
    'aria-label'?: string
}

export type StatProgressBarResolvedVariant = Exclude<StatProgressBarVariant, 'auto'>

export const clampPercent = (value: number) => Math.min(100, Math.max(0, value))

export const getPercentVariant = (percent: number): StatProgressBarResolvedVariant => {
    if (percent >= 80) return 'success'
    if (percent >= 40) return 'warning'
    return 'danger'
}

export const variantBarClass: Record<StatProgressBarResolvedVariant, string> = {
    success: 'bg-[#08AC81]',
    warning: 'bg-[#F59E0B]',
    danger: 'bg-[#FF484B]',
}
